import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "falke_auth_token";
export function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setAuthToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
}

export const api = axios.create({
  baseURL: API,
  // withCredentials nur lokal nötig (Cookie-Auth). In Production nutzen wir Bearer-Token,
  // weil der externe Proxy Access-Control-Allow-Origin auf '*' überschreibt und Cookies
  // damit nicht funktionieren ('*' + credentials ist im Browser verboten).
  withCredentials: false,
});

// Interceptor: Token aus localStorage automatisch in jeden Request einhängen
api.interceptors.request.use((config) => {
  const tok = getAuthToken();
  if (tok) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${tok}`;
  }
  return config;
});

export function resolveImageUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (/^(https?:|data:|blob:)/.test(pathOrUrl)) return pathOrUrl;
  // Storage-Pfad (z.B. "falke-tek/geschenke/uuid.jpg") → über Backend serven
  const clean = pathOrUrl.replace(/^\/?(api\/files\/)?/, "");
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${clean}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : null))
      .filter(Boolean)
      .join(" ") || null;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return null;
}

export function euroFormat(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);
}

export function dateFormat(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
}

export function dateTimeFormat(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
